import { render, staticRenderFns } from "./StandardAPINew.vue?vue&type=template&id=def094aa&"
import script from "./StandardAPINew.vue?vue&type=script&lang=js&"
export * from "./StandardAPINew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports